import ITodo from "../interfaces/ITodo";

const Todo = ({id,completed,content}: ITodo) => {

  return (
        <div className="input-group">
        <input type="checkbox" id={`todo-${id}`} className="app__todo-check" defaultChecked={completed} hidden />
        <label htmlFor ={`todo-${id}`} className="app__todo-label">
          <i className="app__todo-checker"></i>
          {content}
        </label>
        <button className="input-group__delete-btn" aria-label={`delete-todo-${id}`}></button>
      </div>
    )
}

export default Todo